import React, { ReactNode } from 'react';
import { Box } from '@mui/material';
import NavBar from './NavBar';
import VoidBackdrop from './VoidBackdrop';
import WhatsNewDialog from './WhatsNewDialog';
import { zIndex } from '../theme/tokens';
import { usePresenceSync } from '../hooks/usePresenceSync';

/** App shell: the parallax void, the console's top rail, and the page body
 * riding above both. The backdrop is mounted once here rather than per-page
 * so it never restarts its drift on a route change — the console moves, the
 * space behind it doesn't reload. */
const Layout: React.FC<{ children: ReactNode }> = ({ children }) => {
  // One live presence connection for every page (see usePresenceSync).
  usePresenceSync();
  return (
  <>
    <VoidBackdrop />
    <Box sx={{ position: 'relative', zIndex: zIndex.content, minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <NavBar />
      <Box sx={{ flex: 1, px: { xs: 2, md: 4 }, pt: { xs: 2.5, md: 3.5 }, pb: { xs: 4, md: 6 } }}>{children}</Box>
    </Box>
    {/* Mounted once here rather than per-page, same reasoning as the
        backdrop above it: a route change must not remount the dialog and
        re-run its "have I seen this version" check every time. */}
    <WhatsNewDialog />
  </>
  );
};

export default Layout;
